<template>
    <article :id="`person-${person.id}`" class="person-card">
        <div class="person-card-media">
            <div class="person-thumbnail">
                <UiImage :src="person.photo[0].webp" :classes="'responsive full'" />
            </div>
        </div>
        <div class="person-card--info">
            <h6 class="person-card--title">{{ person.title }}</h6>
            <div class="person-card--position">{{ person.teamPosition }}</div>
        </div>
    </article>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        person?: CmsItem;
    }>(),
    {
        person: () => ({})
    }
);

const person = computed(() => props.person);
</script>
